<script>
  import { onMount } from "svelte";
  import { getNextId } from "../Common/tools";
  import NewList from "./NewList.svelte";
  import {External, M} from "../external";

  export let data,
    showNewListButton = false,
    message = M.CHOOSE_SUBSCRIBER_LIST;
  let lists = [];

  onMount(function () {
    External.Tools.makeWebsiteRequest({
      action: "getMarketingLists",
      onOk: function (response) {
        if (response.data == null) {
          return;
        }

        lists = response.data;
      }
    });
  });

  export function get() {
    return data;
  }

  function createList() {
    const buttons = [
      External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, function (popup, context) {
        let formData = popup.component().get();
        formData.id = getNextId(lists);

        External.Tools.makeWebsiteRequest({
          action: "setMarketingLists",
          data: {
            isNew: true,
            data: JSON.stringify(formData)
          },
          onOk: function (response) {
            lists = response.data;
            popup.close();
          }
        });
      }),
      External.Button.MIDDLE_CLOSE
    ];

    External.Tools.showWindow({
      isModal: false,
      title: M.NEW_LIST,
      width: 500,
      buttons: buttons,
      markup: '<div class="popup-widget-wrapper"></div>',
      action: {
        onShow: function (popup, context) {
          popup.bindComponent(
            new NewList({
              target: context.find(".popup-widget-wrapper")[0],
              props: {
                data: {}
              }
            })
          );
        }
      }
    });
  }
</script>

<div class="f-left col20 mt-25">
  <div class="popup-input-wrapper">
    <h5 class="f-15">{M.LIST}</h5>
    <span class="light-gray-text">{message}</span>
    <select bind:value={data.list}>
      <option value="">{M.SELECT_LIST}</option>
      {#each lists as list (list)}
        <option value={list.id}>{list.name}</option>
      {/each}
    </select>
    {#if showNewListButton}
      <div class="f-right"><a class="blue-text" on:click={createList}>{M.CREATE_LIST}</a></div>
    {/if}
  </div>
</div>
